export enum EnabledFilterEnum {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
